module.exports = __webpack_public_path__ + "static/concept1-pc-4bb3cc45291a4cea6e2e71e05703badb.svg";